import { render, staticRenderFns } from "./AddCompanyComponent.vue?vue&type=template&id=5862aa48&scoped=true"
import script from "./AddCompanyComponent.vue?vue&type=script&lang=js"
export * from "./AddCompanyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862aa48",
  null
  
)

export default component.exports